'use client'

export default function LandingBlockHowDoesItHelp(props: any) {
    return (
        <div style={{maxWidth: 600}} className={"px-4 lg:px-0"}>
            <div className={"text-xl mb-7 font-light"}>
                <span className={"text-4xl font-semibold"}>How does it help? 🧐</span>
                <div>
                    <div className={"border-b border-b-fuchsia-300 w-10 md:w-20 lg:w-96 my-7"}></div>
                </div>
            </div>
            <div className={"text-xl mb-7 md:mb-4 lg:mb-3 font-light"}>
                Increase profits by working with trades that have highest profit probability.
            </div>
            <div className={"text-xl mb-7 md:mb-4 lg:mb-3 font-light"}>
                <span className={"font-bold"}>We scan</span>, you get tons of trades ideas. In one click. Automated.
            </div>
            <div className={"text-xl mb-7 md:mb-4 lg:mb-3 font-light"}>
                {`No need to manually search hundreds of companies.`}
            </div>
            <div className={"text-xl mb-7 md:mb-4 lg:mb-3 font-light"}>
                No need to check and look over hundreds of option chains.
            </div>
            <div className={"text-xl mb-7 md:mb-4 lg:mb-3 font-light"}>
                We <span className={"font-bold"}>automatically compare</span> all the possible strategy variations for you.
                <div className={"text-sm text-gray-500 mt-2"}>
                    All expirations. All strikes. All deltas. All spreads. All greeks.
                </div>
            </div>
            <div className={"text-xl mb-7 md:mb-4 lg:mb-3 font-light"}>
                After millions of variations <span
                className={"font-bold"}>you get</span> the trades that match your criteria.
            </div>
            <div className={"text-xl mb-7 md:mb-4 lg:mb-3 font-light"}>
                And we tell you why the trade is better than others.
                {/*And you get a trade report: why the trade is good.*/}
            </div>
        </div>
    )
}
